import { PaymentRequestReminderSummaryModel } from "./paymentRequestReminderSummary.model";
import { WorkflowTaskSummaryModel } from "../../../../../../workflow/task/api/model/common/workflowTaskSummary.model";

export class PaymentRequestReminderModel {
    summary: PaymentRequestReminderSummaryModel;
    workflowTasks: WorkflowTaskSummaryModel[] = [];
}
